/**
 * Mobile nav toggle.
 * Controls aria-expanded on the button and is-open on the menu.
 */
const toggle = document.querySelector('.site-menu__toggle');
const menu   = document.querySelector('.site-menu__list');

if (toggle && menu) {
	toggle.addEventListener('click', () => {
		const isOpen = toggle.getAttribute('aria-expanded') === 'true';
		toggle.setAttribute('aria-expanded', String(!isOpen));
		menu.classList.toggle('is-open', !isOpen);
	});

	// Close when clicking outside.
	document.addEventListener('click', (e) => {
		if (!toggle.contains(e.target) && !menu.contains(e.target)) {
			toggle.setAttribute('aria-expanded', 'false');
			menu.classList.remove('is-open');
		}
	});

	// Close on Escape.
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			toggle.setAttribute('aria-expanded', 'false');
			menu.classList.remove('is-open');
			toggle.focus();
		}
	});
}
